let language = {
    STORE_SETTING_ISSUE_PAGE_LOADING_TITLE: "Page Loading Issue",
    STORE_SETTING_ISSUE_PAGE_LOADING_CONTENT: "An issue occurred while loading this page.Please refresh the page and try again. If the problem persists, feel free to contact our support team at {{supportmail}}.",
    "A109B263542786": "The store information is invalid.",
    STORE_SETTING_URL_INVALID_PARAM_TITLE: "Invalid URL",
    STORE_SETTING_URL_PARAM_MISSING_CONTENT: "The store setting URL is invalid. Please return to the previous page and try again. If you need further assistance, feel free to contact our support team at {{supportmail}}.",
    // 参数缺失
    "A109B263548911": "The \"{{missingField}}\" is missing when trying to open the store setting.",
    CUSTOMER_ORDER_LIST_ORDER_FOUND: "order found",
    CUSTOMER_ORDER_LIST_ORDER_SELECTED: "order selected",
    CUSTOMER_ORDER_LIST_COMBINE_SELECTED: "COMBINE SELECTED",
    CUSTOMER_ORDER_LIST_COMBINE_ALL: "COMBINE ALL",
    CUSTOMER_ORDER_LIST_PRODUCT: "Product",
    CUSTOMER_ORDER_LIST_ORDER_NO: "Order No",
    CUSTOMER_ORDER_LIST_DATE: "Date",
    CUSTOMER_ORDER_LIST_COUNTRY: "Ship To",
    CUSTOMER_ORDER_LIST_PRICE: "Price",
    CUSTOMER_ORDER_LIST_END: "THE END",
    BULKABLE_ITEM_LIST_TITLE: "COMBINE ORDER SUMMARY",
    BULKABLE_ITEM_LIST_TOTAL: "SubTotal",
    BULKABLE_ITEM_LIST_CHECKOUT: "CHECKOUT",

    // tips
    CUSTOMER_ORDER_LIST_PRODUCT_VALIABLE: "The product does not exist. Please create this product again before proceeding",
    CUSTOMER_ORDER_LIST_COMBINE_ORDER_EMPTY: "Your customer order list is empty.",
    BULKABLE_ITEM_LIST_COMBINE_ORDER_EMPTY: "Your bulkable item list is empty."
};

export { language }